import inMemoryJWT from "../../auth/inMemoryJwt";
import Swal from "sweetalert2";
import { urlServer } from "../../config/GlobalConstant";
import { CREATE_PRODUCT, CREATE_SUBCATEGORY_PRODUCTS, DELETE_PRODUCT, DELETE_SUBCATEGORY_PRODUCTS, EDIT_PRODUCT, EDIT_SUBCATEGORY_PRODUCTS, ERROR_PRODUCT, IS_LOADING_LANDINGS, IS_LOADING_PRODUCTS, LIST_OF_PRODUCTS, LIST_SUBCATEGORY_PRODUCTS } from "./types";

const toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
  });
export const createProduct = (createProduct) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_PRODUCTS
    });
    await fetch(`${urlServer}products/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:  JSON.stringify(createProduct)
    })
    .then(response => response.json())
    .then(respJson => {
        console.log();
        if(respJson.success){
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CREATE_PRODUCT,
                payload: respJson.data
            });
        }else{
            dispatch({
                type: ERROR_PRODUCT
            });
            //TODO TOAST
        }
        
    })
}

export const SeeProductsByWinery = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: IS_LOADING_PRODUCTS
    });
    await fetch(`${urlServer}products/get-products-by-any-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header   
        body:  JSON.stringify({locationID:id}) 
    })
    .then(response => response.json())
    .then(respJson => {
        console.log()
        dispatch({ //Esto se lo envía a combineReducer, el que está en el index
            type: LIST_OF_PRODUCTS,
            payload: respJson.data  
        });

    })
    .catch(error => {
        console.log()
    })
   
}
export const SeeSubCategories = () => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: "IS_LOADING_SUB_CATEGORIES"
    });
    await fetch(`${urlServer}adminproductsubcategoires/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
    .then(response => response.json())
    .then(respJson => {
        console.log()
        dispatch({ //Esto se lo envía a combineReducer, el que está en el index
            type: "LIST_OF_SUB_CATEGORIES",
            payload: respJson.data  
        });

    })
    .catch(error => {
        console.log()
    })
   
}
export const SeeSubCategoriesById = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
        type: "IS_LOADING_SUB_CATEGORIES"
    });
    await fetch(`${urlServer}adminproductsubcategoires/get-category-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:JSON.stringify({
            categoryID:id
        })
    })
    .then(response => response.json())
    .then(respJson => {
        console.log()
        if(respJson.success){
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_SUBCATEGORY_PRODUCTS,
                payload: respJson.data  
            });
        }else{
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_SUBCATEGORY_PRODUCTS,
                payload: []  
            });
        }

    })
    .catch(error => {
        console.log()
    })
   
}
export const deleteProduct = (id) => async dispatch => {
    dispatch({ //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
        type: IS_LOADING_PRODUCTS
    });
    await fetch(`${urlServer}products/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:  JSON.stringify({productID:id})
    })
    .then(response => response.json())
    .then(respJson => {
        dispatch({ //Esto se lo envía a combineReducer, el que está en el index
            type: DELETE_PRODUCT,
            payload: id
        });
    })
}
export const createSubcategoryProduct = (name,categoryID,clear) => async dispatch => {

    await fetch(`${urlServer}adminproductsubcategoires/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:  JSON.stringify({name,categoryID})
    })
    .then(response => response.json())
    .then(respJson => {
        if (respJson.success) {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: CREATE_SUBCATEGORY_PRODUCTS,
                payload: respJson.data
            });
            clear()
        }else{
            toast.fire({
                icon: "error",
                text: respJson.error.code ==="ERR032" ? "Ya existe una subcategoría con el mismo nombre" : "No se pudo crear la subcategoría"
              })
        }
        
    })
}
export const editSubcategoryProduct = (name,categoryID,id,clear) => async dispatch => {

    await fetch(`${urlServer}adminproductsubcategoires/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:  JSON.stringify({name,categoryID,subcategoryID:id})
    })
    .then(response => response.json())
    .then(respJson => {
        if (respJson.success) {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: EDIT_SUBCATEGORY_PRODUCTS,
                payload: respJson.data
            });
            clear()
        }else{
            toast.fire({
                icon: "error",
                text: respJson.error.code ==="ERR032" ? "Ya existe una subcategoría con el mismo nombre" : "No se pudo editar la subcategoría"
              })
        }
        
    })
}

export const deleteSubcategoryProduct = (id,close) => async dispatch => {

    await fetch(`${urlServer}adminproductsubcategoires/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:  JSON.stringify({subcategoryID:id})
    })
    .then(response => response.json())
    .then(respJson => {
        if (respJson.success) {
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_SUBCATEGORY_PRODUCTS,
                payload: id
            });
            close()
        }else{
            toast.fire({
                icon: "error",
                text: "No se pudo eliminar la subcategoría"
              })
        }
        
    })
}